module.exports = __webpack_public_path__ + "static/img/title@3x.331a0e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/title@3x.png
// module id = gy66
// module chunks = 0